<h2 mat-dialog-title>
    {{'SCHEDULE.SELECT_GAMES' | translate | uppercase}}
    
  </h2>

<mat-dialog-content class="dialog-scroll-content ">

            <mat-selection-list #gamelist [multiple]="true" class="dense-selection-list games-list" >
                <!-- <ng-container *ngFor="let game of this.game.Games" > -->
                 
                 @for (game of this.game.Games; track game.GameId; let i = $index) {
                 
                    @if (i === 0 || game.DivisionName !== this.game.Games[i - 1].DivisionName) {
                        <mat-divider></mat-divider>           
                        <span style="font-weight: bold; padding: 8px; display: block;">{{game.DivisionName}}</span>
                    }
                 
                    <mat-list-option [value]="game.GameId" >                                                
                            <span matListItemTitle>{{game.HomeTeamName}} - {{game.AwayTeamName}}</span>                                                                                
                    </mat-list-option>
                    
                               
                } @empty {
                    <span>{{'SCHEDULE.NO_GAMES_AVAILABLE' | translate}}</span>
                }
                
               <!--  </ng-container> -->
            </mat-selection-list>
        <!--   <mat-list  #gamelist >
            @for (game of this.game.Games; track game.GameId) {
                <mat-list-item                            >
                                <span matListItemTitle>{{game.HomeTeamName}} <br/> {{game.AwayTeamName}}</span>
                                <span matListItemLine>{{game.DivisionName}}</span>
                                <span>{{game.GameDate| date: 'dd/MM/yyyy HH:mm'}}</span>
                </mat-list-item>
            } @empty {
                 <span>{{'SCHEDULE.NO_GAMES_AVAILABLE' | translate}}</span>
            }
            </mat-list>    -->
</mat-dialog-content>
      
<mat-dialog-actions align="end">
    <mat-divider></mat-divider>
      
      <button mat-button [mat-dialog-close]="gamelist.selectedOptions.selected" cdkFocusInitial >SELECT</button>
      <button mat-button [mat-dialog-close]="false" >CANCEL</button>
    
  
</mat-dialog-actions>
